import revokeTokenHandler from '../../pattern_utilities/revokeTokenHandler';
import { tryToUpdatePattern } from './a.p.PUT.update-pattern.js'

var pf_config = require('../../pf_config.json');
var Cookies = require('js-cookie');

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// UPDATE PATTERN
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

var calculateTimeout;
var calculateTimeoutMillis = 1000;

export const requestCalculatePattern = data => ({
  type: 'REQUEST_CALCULATE_PATTERN',
  data
})

export const receiveCalculatePatternSuccess = data => ({
  type: 'RECEIVE_CALCULATE_PATTERN_SUCCESS',
  data
})

export const receiveCalculatePatternFail = data => ({
  type: 'RECEIVE_CALCULATE_PATTERN_FAIL',
  data
})

export const tryToCalculatePattern = data => (dispatch, getState) => {

  var packet = Object.assign({}, data);

  dispatch(requestCalculatePattern(packet));

  let token = Cookies.get(process.env.REACT_APP_COOKIE_AUTH);
  let headers = {
    "Content-Type": "application/json",
  }
  if(token){
    headers["Authorization"] = "Bearer " + token;
  }

  let url = '/api/patterns/calculate/' + packet.calculator;
  let team = getState().team;
  if(team.current && team.cache[team.current]){
    url += '/team/' + team.cache[team.current].id;
  }

  // console.log('set', JSON.stringify(packet.variables, null, 2));

  clearTimeout(calculateTimeout);
  calculateTimeout = setTimeout((e)=>{
    // console.log('run', JSON.stringify(packet.variables, null, 2));
    return fetch(url, {
        method: 'post',
        body: JSON.stringify(packet.variables),
        headers: headers
      })
      .then((response) => {
        let json = response.json();
        if (response.status >= 200 && response.status < 300) return json;
        return json.then(Promise.reject.bind(Promise));
      })
      .then(function(json){
        for(var i in json.rows){
          for(var j = 1; j < json.rows[i].cells.length; j++){
            if(json.rows[i].cells[j] !== ''){
              json.rows[i].cells[j] *= (packet.scale_factor || 1);
            }
          }
        }

        dispatch(receiveCalculatePatternSuccess({
          id: packet.id,
          cacheID: packet.cacheID,
          rows: json.rows,
          variables: json.variables
        }));

        if(packet.cacheID !== 'local' && getState().patternManager.cache[packet.cacheID].linkedToServer && getState().globalReducer.autoSave){
          dispatch(tryToUpdatePattern(getState().patternManager.cache[packet.cacheID]));
        }
      })
      .catch(e => {
        revokeTokenHandler(e);
        dispatch(receiveCalculatePatternFail({errors:e, lastSubmit: packet}));
      })
  }, calculateTimeoutMillis)
}



// WEBPACK FOOTER //
// ./src/actions/pattern/a.p.POST.calculate-pattern.js